export default "__VITE_ASSET__DPYgLMiL__"